import { faComment as fasComment } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { __, FormTextArea } from "@shared/ui";
import type { ReactNode } from "react";
import type { LeadFormProps, LeadFormStepFields } from "./BasicLeadForm";
import { BasicLeadForm } from "./BasicLeadForm";

export interface LeadFormWithQuestionStepFields extends LeadFormStepFields {
	question?: string;
}

export interface LeadFormWithQuestionProps extends LeadFormProps {
	questionPlaceholder?: string;
}

export class BasicLeadFormWithQuestion<
	StepFields extends LeadFormWithQuestionStepFields = LeadFormWithQuestionStepFields,
	Props extends LeadFormWithQuestionProps = LeadFormWithQuestionProps,
> extends BasicLeadForm<StepFields, Props> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		questionPlaceholder: __("Kérdés"),
	};

	protected initValues(): StepFields {
		return {
			...super.initValues(),
			question: undefined,
		};
	}

	protected renderFields(): ReactNode {
		const { submitState, questionPlaceholder } = this.props;

		return (
			<>
				{super.renderFields()}
				<FormTextArea
					placeholder={questionPlaceholder}
					name="question"
					prepend={<FontAwesomeIcon icon={fasComment} />}
					disabled={submitState !== undefined}
				/>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.BasicLeadFormWithQuestion`;
	}
}
